export type PopupAutofillScheme =
  | { type: 'unhandled'; }
  | { type: 'invalid'; }
  | { type: 'autofill'; prompt: string; };

/** 仅识别本次临时协议；错误的 autofill 参数也必须接管，避免回退唤起客户端。 */
export function parsePopupAutofillScheme(scheme: string): PopupAutofillScheme {
  let url: URL;
  try {
    url = new URL(scheme);
  } catch {
    return /^mtroboneo:\/\/(?:[^/?#]*@)?autofill(?=[:/?#]|$)/i.test(scheme.trim())
      ? { type: 'invalid' } : { type: 'unhandled' };
  }
  if (url.protocol !== 'mtroboneo:' || url.hostname.toLowerCase() !== 'autofill') {
    return { type: 'unhandled' };
  }
  if (url.username || url.password || url.port || (url.pathname && url.pathname !== '/') || scheme.includes('#')) {
    return { type: 'invalid' };
  }

  try {
    // 直接解码原始 query，避免 URLSearchParams 宽松替换非法 UTF-8 或 URL 丢弃未编码换行。
    const queryStart = scheme.indexOf('?');
    const values: string[] = [];
    if (queryStart !== -1) {
      scheme.slice(queryStart + 1).split('&').forEach((part) => {
        const separator = part.indexOf('=');
        const key = separator === -1 ? part : part.slice(0, separator);
        if (decodeURIComponent(key.replace(/\+/g, ' ')) === 'prompt') {
          const value = separator === -1 ? '' : part.slice(separator + 1);
          values.push(decodeURIComponent(value.replace(/\+/g, ' ')));
        }
      });
    }
    if (values.length !== 1 || !values[0].trim()) return { type: 'invalid' };
    return { type: 'autofill', prompt: values[0] };
  } catch {
    return { type: 'invalid' };
  }
}
